// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SessionExpiredDialog-module__modalDialog--mH6mA{width:26rem}.SessionExpiredDialog-module__content--W1_5x{font-size:.75rem;text-align:center}.SessionExpiredDialog-module__header--L23W7{font-weight:500;font-size:1rem;color:var(--xm-main-text-color);padding-bottom:.4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalDialog": "SessionExpiredDialog-module__modalDialog--mH6mA",
	"content": "SessionExpiredDialog-module__content--W1_5x",
	"header": "SessionExpiredDialog-module__header--L23W7"
};
export default ___CSS_LOADER_EXPORT___;
